import './SliderSocios.css';

function SliderSocios() {
  const logos = [
    "Cliente1.png",
    "Cliente2.png",
    "Cliente3.png",
    "Cliente4.svg",
    "Cliente5.png",
    "Cliente6.png",
    "Cliente7.png"
  ];

  // Triplicamos para asegurar que nunca quede espacio vacío
  const repeatedLogos = [...logos, ...logos, ...logos];

  return (
    <div className="logos">
      <h2 className="Subtitle-h2 edit-title-h2-secC">
        NUESTROS CLIENTES
      </h2>

      <div className="logos-slide">
        {repeatedLogos.map((logo, index) => (
          <div className="logo-item" key={index}>
            <img
              src={`img/Clientes-img/${logo}`}
              alt="cliente"
            />
          </div>
        ))}
      </div>
    </div>
  );
}

export default SliderSocios;